<template>
  <div>
    <h4 style="padding-left: 12px;">
      <b>Payment Cards</b>
    </h4>
    <v-layout row wrap align-start>
      <v-flex pa-1 lg12 md12>
        <ul>
          <li v-for="card in bookingForm.user.cards">
            <v-layout row align-center>
              <p>{{ card.brand + " " + card.last4 }}</p>
              <v-btn @click="removeCardDialog(card)" icon>
                <v-icon>delete</v-icon>
              </v-btn>
            </v-layout>
          </li>
        </ul>
      </v-flex>
    </v-layout>
    <v-row>
      <v-flex pr-2 shrink>
        <v-btn @click="addingCard = true" class="text-none">Add Card</v-btn>
      </v-flex>
      <a
        target="_blank"
        :href="`${'https://dashboard.stripe.com/search?query='+bookingForm.user.id}`"
      >View Customer on Stripe</a>
    </v-row>
    <v-dialog persistent v-model="addingCard" min-width="100%" max-width="600">
      <v-card>
        <v-card-actions>
          <v-layout row justify-space-between>
            <v-card-title class="headline" style="font-weight: 600;">Add Card</v-card-title>
            <v-btn icon flat="flat" @click="addingCard = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-card-actions>

        <CardInput :bookingForm="bookingForm" @gotCard="cardAdded" />
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Remove Card</v-card-title>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn class="text-none" flat text @click="dialog = false">Close</v-btn>
          <v-btn class="text-none" flat text @click="dialog = false; removeCard(card)">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SelectableCardInput from "@/components/widget/input/SelectableCardInput.vue";

import CardInput from "@/components/widget/input/CardInput.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "PaymentCards",
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    SelectableCardInput,
    CardInput
  },
  props: {
    content: String,
    label: String,
    errorMessages: Object,
    bookingForm: Object
  },
  data() {
    return {
      menu: false,
      addingCard: false,
      dialog: false,
      card: {}
    };
  },
  computed: {},
  methods: {
    cardAdded(token) {
      this.addingCard = false;
    },
    removeCardDialog(card) {
      this.card = card;
      this.dialog = true;
    },
    async removeCard(card) {
      try {
        let response = await axios.post(
          `${this.$store.state.apiUrl}/customer/removeCardByToken?card=${card.id}&user_id=${this.bookingForm.user.id}`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );

        if (response.data.error == "no_error") {
          this.bookingForm.user.cards = this.bookingForm.user.cards.filter(
            function(c) {
              return c.id != card.id;
            }
          );

          alert("Card removed");
        } else {
          if (response.data.message != null) {
            alert(response.data.message);
          } else {
            alert(response.data.error);
          }
        }
      } catch (error) {
        console.log(error);
        return "unknown_error";
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.disabled-panel {
  pointer-events: none;
}

.enabled-panel {
  pointer-events: auto;
}

.change-cost-panel {
  background-color: #e3f2fd;
}

.compact-form {
  transform: scale(0.875);
  transform-origin: left;
}

.small-fab {
  transform: scale(0.7);
  transform-origin: bottom;
}

.small-fab button {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
</style>
